<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :span="22" :offset="1"  class="page-title-stakeholder">{{pageTitle}}</el-col>
      <el-col :span="22" :offset="1" class="add-btn">
        <el-button type="danger" @click="showUploadDialog" :disabled="addButtonStatus">{{buttonAdd}}</el-button>
      </el-col>
      <el-col :span="22" :offset="1">
        <AssessmentTable v-bind:dataSource="dataSource" v-bind:assessmentType="assessmentType" v-bind:stakeholderConfirmText="stakeholderConfirmText" v-bind:buttonCancel="buttonCancel"  v-bind:buttonConfirm="buttonConfirm" v-on:initAssessment="initAssessmentList" v-on:modifiedAddButton="modifiedAddButton"></AssessmentTable>
        <el-dialog title="Upload" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
          <div style="margin-left: -48px">
          <UploadAssessment  v-bind:userType="assessmentType" v-bind:fileClear="fileClear" ref="uploadAssessment" v-on:closeUpload="closeUpload"></UploadAssessment>
          </div>
            <span slot="footer">
            <el-button @click="hideDialog">{{buttonCancel}}</el-button>
            <el-button type="danger" @click="clickPreview">{{buttonPreview}}</el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-col>
    <Footer v-on:init="init"></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import { questionnaireList } from '@/services/answerer/questionnaire.service';
import Constant from '@/common/Constant'
import UploadAssessment from '@/pages/UploadAssessment.vue'
import Header from '@/components/Header.vue'
import AssessmentTable from '@/components/AssessmentTable.vue';
import CommonHelper from '@/utils/commonHelper';

export default {
  components: {
    Footer,
    Header,
    UploadAssessment,
    AssessmentTable
  },
  data () {
    return {
      dialogVisible: false,
      addButtonStatus: false,
      dataSource: [],
      assessmentType: Constant.TYPE_STAKEHOLDER,
      pageTitle: '',
      buttonPreview: '',
      buttonAdd: '',
      buttonConfirm: '',
      buttonCancel: '',
      stakeholderConfirmText: '',
      fileClear: false
    }
  },
  methods: {
    closeUpload () {
      this.dialogVisible = false;
    },
    modifiedAddButton () {
      for (let i = 0; i < this.dataSource.length; i++) {
        let date = new Date().getFullYear().toString();
        if (this.dataSource[i].year === date && this.dataSource[i].status === Constant.ASSESSMENT_STATUS_CONFIRMED) {
          this.addButtonStatus = true;
          break;
        }
      }
    },
    showUploadDialog () {
      this.dialogVisible = true;
    },
    hideDialog () {
      this.dialogVisible = false;
      this.fileClear = !this.fileClear;
    },
    handleClose (done) {
      this.fileClear = !this.fileClear;
      done();
    },
    clickPreview () {
      if (this.$refs.uploadAssessment.fileList.length === 0) {
        this.$alert('File is null , please try again.', {
          confirmButtonText: 'OK'
        });
      } else {
        let {href} = this.$router.resolve({name: 'AssessmentPreview'});
        window.open(href, '_blank');
        this.dialogVisible = false;
      }
      this.fileClear = !this.fileClear;
    },
    async initAssessmentList () {
      this.$loading({fullscreen: true});
      const assessments = await questionnaireList();
      this.dataSource = assessments.data;
      this.dataSource.forEach(item => {
        item.newModifiedDate = CommonHelper.formatDate(item.modifiedDate);
        item.newCreatedDate = CommonHelper.formatDate(item.createdDate);
      })
      this.modifiedAddButton();
      this.$loading({fullscreen: true}).close();
    },
    init () {
      this.pageTitle = this.$store.state.dictionary[1].MAINMENANCE_QUESTIONNAIRE_TITLE_STAKEHOLDER;
      this.buttonAdd = this.$store.state.dictionary[1].BUTTON_ADD_QUESTIONNAIRE;
      this.buttonPreview = this.$store.state.dictionary[1].BUTTON_PREVIEW;
      this.buttonConfirm = this.$store.state.dictionary[1].BUTTON_CONFIRM;
      this.buttonCancel = this.$store.state.dictionary[1].BUTTON_CANCEL;
      this.stakeholderConfirmText = this.$store.state.dictionary[1].STAKEHOLDER_CONFIRM_TEXT;
    }
  },
  mounted () {
    sessionStorage.setItem(Constant.ASSESSMENT_TYPE, Constant.TYPE_STAKEHOLDER)
    this.initAssessmentList();
  },
  beforeDestroy () {
    this.$loading({fullscreen: true}).close();
  }
};
</script>

<style scoped>
  .text-align-left {
    text-align: left;
  }

  .page-title-stakeholder{
    font-size: 20px;
    margin-top: 80px;
  }

  .add-btn{
    padding: 30px 0 15px 0;
  }

  /*rewrite element-ui */
  >>>.el-button{
    border-color: #5e89ed;
    color: #5e89ed;
  }

  >>>.el-button:hover{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #f4f5f7;
  }

  >>>.el-button--primary {
    border-color: #5e89ed!important;
    color: #5e89ed!important;
  }
  >>>.el-button--primary:hover{
    background-color: #4b6ebe!important;
    border-color: #4b6ebe!important;
    color: #fff!important;
  }

  >>>.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }
  >>>.el-button--danger.is-disabled, .el-button--danger.is-disabled:active, .el-button--danger.is-disabled:focus, .el-button--danger.is-disabled:hover {
    color: #fff;
    background-color: #9ecdfde6;
    border-color: #9ecdfde6;
  }

  >>>.el-button:focus{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #f4f5f7;
  }

  >>>.el-button--danger{
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger:hover{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button--danger:focus{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }
  >>>.el-table{
    color: black;
  }

  >>>.el-table thead{
    color: black;
  }
  >>>.el-dialog__body {
    padding: 30px 70px;
    color: #606266;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/StakeholderQuestionnaire.vue